import { type ExperimentValue } from '@stone-payments/experiment/src/lib/types'

export type SweepAccountsOnboardingItem = {
  item_text: string
  jade_icon: string
}

export type SweepAccountsOnboardingContent = {
  title: string
  description: string
  image_url: string
  button_label: string
  onboarding_completed_id: string
  items: SweepAccountsOnboardingItem[]
}

export type SweepAccountsOnboardingExperimentPayload = {
  title?: string
  description?: string
  image_url?: string
  button_label?: string
  onboarding_completed_id?: string
  items?: SweepAccountsOnboardingItem[]
  ignore_default_content?: boolean
}

export const defaultSweepAccountsOnboardingContent: SweepAccountsOnboardingContent = {
  title: 'Deixe o saldo rendendo na conta',
  description: 'Conheça os principais benefícios e recursos disponíveis para você.',
  image_url: 'https://stone-public-assets.pages.dev/investment/onboarding/img_sweep_accounts_onboarding.webp',
  button_label: 'Conferir rendimentos',
  onboarding_completed_id: 'sweep_accounts_onboarding_completed',
  items: [
    { item_text: 'Rende 100% do CDI', jade_icon: 'jade_file_folded' },
    { item_text: 'Sem exigência de valor mínimo', jade_icon: 'jade_lamp' },
    { item_text: 'Acompanhe os rendimentos no Extrato', jade_icon: 'jade_lock_close' },
    { item_text: 'Conte com suporte sempre que precisar.', jade_icon: 'jade_microphone' }
  ]
}

export const defaultSweepAccountsOnboardingExperimentPayload: ExperimentValue<SweepAccountsOnboardingExperimentPayload> =
  {
    value: 'control',
    payload: defaultSweepAccountsOnboardingContent
  }
